import React from 'react'
import FilterTabs from 'components/filterTabs'
import { staticFilterPage } from 'enums/staticFilterPage'
import { AVAILABLE_COLUMNS_SIMPLE as AVAILABLE_COLUMNS } from 'store/modules/bottlesFilter/columns'

export default () => {
  return <FilterTabs page={staticFilterPage.bottlesSimple} availableColumns={AVAILABLE_COLUMNS} />
}
